import React from 'react';

import {stopPropagation} from '@edna/utils';

import {useTheme} from '../styles';
import {EPlacementX, EPlacementY, ESize, TPlacementX, TPlacementY, TSize} from '../types';
import * as S from './style';

export type TProps = {
  className?: string;
  content: React.ReactNode | string;
  onOpen?: TEmptyFunction;
  size?: TSize;
  placementX?: TPlacementX;
  placementY?: TPlacementY;
  head?: React.ReactNode;
  overlayComponent?: TAnyComponent;
  headComponent?: TAnyComponent;
  hasMarginLeft?: boolean;
  hasMarginRight?: boolean;
  hoverDelay?: number;
  disableHoverOverlay?: boolean;
};

const InfoDropdown = React.memo<TProps>(
  ({
    className,
    content,
    onOpen,
    size = 'M',
    placementX,
    placementY,
    head,
    overlayComponent: OverlayComponent = S.InfoDropdownOverlay,
    headComponent: HeadComponent = S.InfoDropdownHead,
    hasMarginLeft,
    hasMarginRight,
    hoverDelay,
    disableHoverOverlay,
  }) => {
    const theme = useTheme();

    if (!content) {
      return null;
    }

    return (
      <S.Dropdown
        hasOverlayArrow
        className={className}
        hasMarginLeft={hasMarginLeft}
        hasMarginRight={hasMarginRight}
        headComponent={HeadComponent}
        head={head ?? <S.InfoOutlinedIcon size={size} onClick={stopPropagation} />}
        overlayColor={theme.palette.grey500}
        overlayComponent={OverlayComponent}
        overlay={<S.InfoDropdownContent>{content}</S.InfoDropdownContent>}
        trigger="hover"
        onOpen={onOpen}
        placementX={placementX}
        placementY={placementY}
        hoverDelay={hoverDelay}
        disableHoverOverlay={disableHoverOverlay}
      />
    );
  },
);

export const {InfoDropdownOverlay} = S;
export const {InfoDropdownHead} = S;
export {EPlacementX, EPlacementY, ESize};
export default InfoDropdown;
